import * as React from 'react';
import { useZustand } from 'use-zustand';
import { pathwayStore } from '../store';
import { Config } from '../helper';

export default function Progress() {
  const currentProgress = useZustand(pathwayStore, (state) => state.currentProgress);

  const current = currentProgress();

  return (
    <div className='sidebar-block nv-learning-pathway-progress'>
      <p className='h--smallest'>
        {Config.I18n.Progress}
      </p>
      <p className='h--small'>{Config.I18n.Complete(current)}</p>
      <div className='btn-group'>
        <div className='progress'>
          <div className='progress-bar' role='progressbar' style={{ width: `${current}%` }} aria-valuenow={current} aria-valuemin='0' aria-valuemax='100'></div>
        </div>
      </div>
    </div>
  );
}
